import React from 'react';
import { Select } from 'antd';

type Props = {
  value: (string | number | boolean)[] | null,
  onChange: (value: (string | number | boolean)[]) => void,
  onBlur: () => void,
  type: 'string' | 'number' | 'boolean',
  isFloat?: boolean,
  selectOptions: (string | number | boolean)[],
};

export default function ArrayInput(props: Props) {
  const {
    value,
    onBlur,
    onChange,
    placeholder,
    selectOptions,
    type,
    isFloat,
  } = props;
  return (
    <Select
      className="tag-input"
      mode="tags"
      placeholder={placeholder}
      style={{ width: '100%' }}
      value={value ? value.map(v => String(v)) : []}
      onBlur={onBlur}
      onChange={newValue => {
        let newValueParsed = [...newValue];
        if (type === 'number') {
          newValueParsed = newValue
            .map(v => Number(v))
            .filter(
              v => !Number.isNaN(v) && (isFloat ? true : Number.isInteger(v)),
            );
        }
        if (type === 'boolean') {
          newValueParsed = newValue
            .filter(v => v === 'true' || v === 'false')
            .map(v => v === 'true');
        }
        onChange(newValueParsed);
      }}
    >
      {selectOptions.map(option => (
        <Select.Option key={option.toString()} value={option.toString()}>
          {option}
        </Select.Option>
      ))}
    </Select>
  );
}
